<template>
    <svg width="23px" height="40px" viewBox="0 0 23 40">
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Button/Icon" transform="translate(-32.000000, -26.000000)">
                <rect id="Rectangle" fill="#FFFFFF" opacity="0" x="0" y="0" width="92" height="92"></rect>
                <g id="Icon/Right" transform="translate(6.000000, 6.000000)" fill="#F0AD23">
                    <path d="M60,26 L60,54 L32,54 L32,50 L56,50 L56,26 L60,26 Z" id="Combined-Shape" transform="translate(46.000000, 40.000000) scale(-1, 1) rotate(-45.000000) translate(-46.000000, -40.000000) "></path>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
    }
</script>

